import React from 'react';
import Header, {HeaderLeft, HeaderRight} from '../../../layout/Header/Header';
import HeaderUserMenu from '../../../layout/User/HeaderUserMenu';
import NotificationBell from '../../../components/notifications/NotificationBell';
import '../../../components/dashboard/transfer-market/transfer-market.css';

const greeting = (hour: number) => (hour < 11 ? 'Bună dimineața' : hour < 18 ? 'Bună ziua' : 'Bună seara');

// Header-ul aplicatiei in designul Transfer market 2.0: salut + data in stanga, notificari si contul in dreapta
const DefaultHeader = () => {
    const user = JSON.parse(`${localStorage.getItem('user')}`);
    if (!user) return null;

    const now = new Date();
    const today = new Intl.DateTimeFormat('ro-RO', {weekday: 'long', day: 'numeric', month: 'long'}).format(now);

    return (
        <Header>
            <HeaderLeft>
                <div className='vtm-hdr vtm-hdr-hello'>
                    <span className='vtm-ki vtm-hdr-title'>{greeting(now.getHours())}</span>
                    <span className='vtm-meta vtm-hdr-date'>{today}</span>
                </div>
            </HeaderLeft>
            <HeaderRight>
                <div className='vtm-hdr vtm-hdr-right'>
                    <NotificationBell/>
                    <span className='vtm-hdr-sep' aria-hidden='true'/>
                    <HeaderUserMenu/>
                </div>
            </HeaderRight>
        </Header>
    );
};

export default DefaultHeader;
